export default {
  orders: [],
  count: 0,
  lastFilter: {},
};



// WEBPACK FOOTER //
// ./src/store/modules/order/state.js